export default function(options) {
  var self = this;

  // Placeholder for potential expansion of this class
  self.defaults = { };

  self.config = _.extend(self.defaults, options);

  self.init = function() {
    self.watchElement(self.config.$element);
  };

  self.watchElement = function($element, type) {
    $(window).on('scroll load', { el: $element }, self.initTransitions);
  };

  self.initTransitions = _.throttle(function(event) {
    if(!event.data || !Kadenze.UIUtil.isInView(event.data.el)) {
      return;
    }

    var $parent = event.data.el,
      $children = self.order($parent.find('[data-transition-order]'));

    self.transition($children);

  }, 500);

  self.transition = function($elements) {
    $elements.each(function() {
      var $this = $(this),
        delay = $this.data('transition-delay');

      setTimeout(function() {
        $this.addClass('transition-in');
      }, delay);
    });
  };

  // Utils

  self.order = function($elements) {
    return $elements.sort(function(a, b) {
      var firstOrder = a.getAttribute('data-transition-order'),
        secondOrder = b.getAttribute('data-transition-order');

      if(firstOrder > secondOrder) {
        return 1;
      }

      if(firstOrder < secondOrder) {
        return -1;
      }

      return 0;
    });
  };

  self.init();

  return self;
}